import { useMemo } from "react"
import { useAppSelector } from "../../../../../../hooks/store-hooks"
import { Pie } from 'react-chartjs-2';
import { Chart as ChartJS, ArcElement, Tooltip as ChartTooltip, Legend } from 'chart.js';
import { Grid, Typography, Box } from "@mui/material";
ChartJS.register(ArcElement, ChartTooltip, Legend);

export const DadosGerais = () => {
    // State
    const { relatorioProjeto } = useAppSelector((state) => state.projetos)

    const phones = useMemo(() => {
        return {
            labels: ['Pessoas com telefone', 'Pessoas sem telefone'],
            datasets: [
                {
                    label: ' Total',
                    data: [
                        relatorioProjeto?.agregacoes.pessoasComTelefone,
                        relatorioProjeto?.agregacoes.pessoasSemTelefone
                    ],
                    backgroundColor: [
                        'rgba(54, 162, 235, 0.2)',
                        'rgba(255, 99, 132, 0.2)'
                    ],
                    borderColor: [
                        'rgba(54, 162, 235, 1)',
                        'rgba(255, 99, 132, 1)'
                    ],
                    borderWidth: 1,
                }
            ]
        }
    }, [relatorioProjeto?.agregacoes.pessoasComTelefone, relatorioProjeto?.agregacoes.pessoasSemTelefone])

    const mobilePhones = useMemo(() => {
        return {
            labels: ['Pessoas com celular', 'Pessoas sem celular'],
            datasets: [
                {
                    label: ' Total',
                    data: [
                        relatorioProjeto?.agregacoes.pessoasComCelular,
                        relatorioProjeto?.agregacoes.pessoasSemCelular
                    ],
                    backgroundColor: [
                        'rgba(54, 162, 235, 0.2)',
                        'rgba(255, 99, 132, 0.2)'
                    ],
                    borderColor: [
                        'rgba(54, 162, 235, 1)',
                        'rgba(255, 99, 132, 1)'
                    ],
                    borderWidth: 1,
                }
            ]
        }
    }, [relatorioProjeto?.agregacoes.pessoasComCelular, relatorioProjeto?.agregacoes.pessoasSemCelular])

    const fixoPhones = useMemo(() => {
        return {
            labels: ['Pessoas com telefone fixo', 'Pessoas sem telefone fixo'],
            datasets: [
                {
                    label: ' Total',
                    data: [
                        relatorioProjeto?.agregacoes.pessoasComFixo,
                        relatorioProjeto?.agregacoes.pessoasSemFixo
                    ],
                    backgroundColor: [
                        'rgba(54, 162, 235, 0.2)',
                        'rgba(255, 99, 132, 0.2)'
                    ],
                    borderColor: [
                        'rgba(54, 162, 235, 1)',
                        'rgba(255, 99, 132, 1)'
                    ],
                    borderWidth: 1,
                }
            ]
        }
    }, [relatorioProjeto?.agregacoes.pessoasComFixo, relatorioProjeto?.agregacoes.pessoasSemFixo])

    const whatsAppPhones = useMemo(() => {
        return {
            labels: ['Pessoas com WhatsApp', 'Pessoas sem WhatsApp'],
            datasets: [
                {
                    label: ' Total',
                    data: [
                        relatorioProjeto?.agregacoes.pessoasComWhatsApp,
                        relatorioProjeto?.agregacoes.pessoasSemWhatsApp
                    ],
                    backgroundColor: [
                        'rgba(54, 162, 235, 0.2)',
                        'rgba(255, 99, 132, 0.2)'
                    ],
                    borderColor: [
                        'rgba(54, 162, 235, 1)',
                        'rgba(255, 99, 132, 1)'
                    ],
                    borderWidth: 1,
                }
            ]
        }
    }, [relatorioProjeto?.agregacoes.pessoasComWhatsApp, relatorioProjeto?.agregacoes.pessoasSemWhatsApp])

    const enderecos = useMemo(() => {
        return {
            labels: ['Pessoas com endereço', 'Pessoas sem endereço'],
            datasets: [
                {
                    label: ' Total',
                    data: [
                        relatorioProjeto?.agregacoes.pessoasComEndereco,
                        relatorioProjeto?.agregacoes.pessoasSemEndereco
                    ],
                    backgroundColor: [
                        'rgba(54, 162, 235, 0.2)',
                        'rgba(255, 99, 132, 0.2)'
                    ],
                    borderColor: [
                        'rgba(54, 162, 235, 1)',
                        'rgba(255, 99, 132, 1)'
                    ],
                    borderWidth: 1,
                }
            ]
        }
    }, [relatorioProjeto?.agregacoes.pessoasComEndereco, relatorioProjeto?.agregacoes.pessoasSemEndereco])

    const emails = useMemo(() => {
        return {
            labels: ['Pessoas com e-mail', 'Pessoas sem e-mail'],
            datasets: [
                {
                    label: ' Total',
                    data: [
                        relatorioProjeto?.agregacoes.pessoasComEmail,
                        relatorioProjeto?.agregacoes.pessoasSemEmail
                    ],
                    backgroundColor: [
                        'rgba(54, 162, 235, 0.2)',
                        'rgba(255, 99, 132, 0.2)'
                    ],
                    borderColor: [
                        'rgba(54, 162, 235, 1)',
                        'rgba(255, 99, 132, 1)'
                    ],
                    borderWidth: 1,
                }
            ]
        }
    }, [relatorioProjeto?.agregacoes.pessoasComEmail, relatorioProjeto?.agregacoes.pessoasSemEmail])

    return (
        <>
            <Grid container>
                <Grid item xs={12}>
                    <Typography align="center" fontWeight="bold" variant="h5" color="primary">
                        Gráficos detalhados
                    </Typography>
                </Grid>
                <Grid item xs={12} md={4}>
                    <Box p={2}>
                        <Grid container justifyContent="center">
                            <Grid item>
                                <Pie color="white" data={phones} />
                            </Grid>
                        </Grid>
                        <Grid
                            container
                            justifyContent={"center"}
                            spacing={2}
                            style={{
                                marginTop: '15px'
                            }}
                        >
                            <Grid item xs={12}>
                                <Typography align="center" fontWeight="bold">
                                    <span
                                        style={{
                                            color: 'rgba(255, 99, 132, 1)'
                                        }}
                                    >
                                        Sem telefone:
                                    </span>  {relatorioProjeto?.agregacoes.pessoasSemTelefone.toLocaleString('pt-BR')}
                                </Typography>
                            </Grid>
                            <Grid item xs={12}>
                                <Typography align="center" fontWeight="bold">
                                    <span
                                        style={{
                                            color: 'rgba(54, 162, 235, 1)'
                                        }}
                                    >
                                        Com telefone:
                                    </span>  {relatorioProjeto?.agregacoes.pessoasComTelefone.toLocaleString('pt-BR')}
                                </Typography>
                            </Grid>
                        </Grid>
                    </Box>
                </Grid>

                <Grid item xs={12} md={4}>
                    <Box p={2}>
                        <Grid container justifyContent="center">
                            <Grid item>
                                <Pie color="white" data={mobilePhones} />
                            </Grid>
                        </Grid>
                        <Grid
                            container
                            justifyContent={"center"}
                            spacing={2}
                            style={{
                                marginTop: '15px'
                            }}
                        >
                            <Grid item xs={12}>
                                <Typography align="center" fontWeight="bold">
                                    <span
                                        style={{
                                            color: 'rgba(255, 99, 132, 1)'
                                        }}
                                    >
                                        Sem celular:
                                    </span>  {relatorioProjeto?.agregacoes.pessoasSemCelular.toLocaleString('pt-BR')}
                                </Typography>
                            </Grid>
                            <Grid item xs={12}>
                                <Typography align="center" fontWeight="bold">
                                    <span
                                        style={{
                                            color: 'rgba(54, 162, 235, 1)'
                                        }}
                                    >
                                        Com celular:
                                    </span>  {relatorioProjeto?.agregacoes.pessoasComCelular.toLocaleString('pt-BR')}
                                </Typography>
                            </Grid>
                        </Grid>
                    </Box>
                </Grid>

                <Grid item xs={12} md={4}>
                    <Box p={2}>
                        <Grid container justifyContent="center">
                            <Grid item>
                                <Pie color="white" data={whatsAppPhones} />
                            </Grid>
                        </Grid>
                        <Grid
                            container
                            justifyContent={"center"}
                            spacing={2}
                            style={{
                                marginTop: '15px'
                            }}
                        >
                            <Grid item xs={12}>
                                <Typography align="center" fontWeight="bold">
                                    <span
                                        style={{
                                            color: 'rgba(255, 99, 132, 1)'
                                        }}
                                    >
                                        Sem WhatsApp:
                                    </span>  {relatorioProjeto?.agregacoes.pessoasSemWhatsApp.toLocaleString('pt-BR')}
                                </Typography>
                            </Grid>
                            <Grid item xs={12}>
                                <Typography align="center" fontWeight="bold">
                                    <span
                                        style={{
                                            color: 'rgba(54, 162, 235, 1)'
                                        }}
                                    >
                                        Com WhatsApp:
                                    </span>  {relatorioProjeto?.agregacoes.pessoasComWhatsApp.toLocaleString('pt-BR')}
                                </Typography>
                            </Grid>
                        </Grid>
                    </Box>
                </Grid>

                <Grid item xs={12} md={4}>
                    <Box p={2}>
                        <Grid container justifyContent="center">
                            <Grid item>
                                <Pie color="white" data={fixoPhones} />
                            </Grid>
                        </Grid>
                        <Grid
                            container
                            justifyContent={"center"}
                            spacing={2}
                            style={{
                                marginTop: '15px'
                            }}
                        >
                            <Grid item xs={12}>
                                <Typography align="center" fontWeight="bold">
                                    <span
                                        style={{
                                            color: 'rgba(255, 99, 132, 1)'
                                        }}
                                    >
                                        Sem telefone fixo:
                                    </span>  {relatorioProjeto?.agregacoes.pessoasSemFixo.toLocaleString('pt-BR')}
                                </Typography>
                            </Grid>
                            <Grid item xs={12}>
                                <Typography align="center" fontWeight="bold">
                                    <span
                                        style={{
                                            color: 'rgba(54, 162, 235, 1)'
                                        }}
                                    >
                                        Com telefone fixo:
                                    </span>  {relatorioProjeto?.agregacoes.pessoasComFixo.toLocaleString('pt-BR')}
                                </Typography>
                            </Grid>
                        </Grid>
                    </Box>
                </Grid>

                <Grid item xs={12} md={4}>
                    <Box p={2}>
                        <Grid container justifyContent="center">
                            <Grid item>
                                <Pie color="white" data={enderecos} />
                            </Grid>
                        </Grid>
                        <Grid
                            container
                            justifyContent={"center"}
                            spacing={2}
                            style={{
                                marginTop: '15px'
                            }}
                        >
                            <Grid item xs={12}>
                                <Typography align="center" fontWeight="bold">
                                    <span
                                        style={{
                                            color: 'rgba(255, 99, 132, 1)'
                                        }}
                                    >
                                        Sem endereço:
                                    </span>  {relatorioProjeto?.agregacoes.pessoasSemEndereco.toLocaleString('pt-BR')}
                                </Typography>
                            </Grid>
                            <Grid item xs={12}>
                                <Typography align="center" fontWeight="bold">
                                    <span
                                        style={{
                                            color: 'rgba(54, 162, 235, 1)'
                                        }}
                                    >
                                        Com endereço:
                                    </span>  {relatorioProjeto?.agregacoes.pessoasComEndereco.toLocaleString('pt-BR')}
                                </Typography>
                            </Grid>
                        </Grid>
                    </Box>
                </Grid>

                <Grid item xs={12} md={4}>
                    <Box p={2}>
                        <Grid container justifyContent="center">
                            <Grid item>
                                <Pie color="white" data={emails} />
                            </Grid>
                        </Grid>
                        <Grid
                            container
                            justifyContent={"center"}
                            spacing={2}
                            style={{
                                marginTop: '15px'
                            }}
                        >
                            <Grid item xs={12}>
                                <Typography align="center" fontWeight="bold">
                                    <span
                                        style={{
                                            color: 'rgba(255, 99, 132, 1)'
                                        }}
                                    >
                                        Sem e-mail:
                                    </span>  {relatorioProjeto?.agregacoes.pessoasSemEmail.toLocaleString('pt-BR')}
                                </Typography>
                            </Grid>
                            <Grid item xs={12}>
                                <Typography align="center" fontWeight="bold">
                                    <span
                                        style={{
                                            color: 'rgba(54, 162, 235, 1)'
                                        }}
                                    >
                                        Com e-mail:
                                    </span>  {relatorioProjeto?.agregacoes.pessoasComEmail.toLocaleString('pt-BR')}
                                </Typography>
                            </Grid>
                        </Grid>
                    </Box>
                </Grid>

            </Grid>
        </>
    )
}